export default "__VITE_ASSET__BkH5n5IB__"